import { Button } from '@/shadcn-ui/button';
import { cn } from '@/shadcn-ui/utils';
import { Label } from '@/shadcn-ui/label';
import {
  PlainSelectTrigger,
  Select,
  SelectContent,
  SelectItem,
} from '@/shadcn-ui/select';
import { SelectItemText, SelectTrigger, SelectValue } from '@radix-ui/react-select';
import ChevronDown from '@/icons/chevron-down';
import Spacer from '@/common/components/spacer';
import useIsClient from '@/util-react-router/hooks/use-is-client';
import { USTerritories } from '../types/us-territories';

interface USTerritorySelectProps {
  selectedState?: string;
  setSelectedState: (state?: string) => void;
  errorText?: string;
  className?: string;
}

export default function USTerritorySelect({
  selectedState,
  setSelectedState,
  errorText,
  className,
}: USTerritorySelectProps) {
  const isClient = useIsClient();

  if (!isClient) {
    // Render a placeholder during SSR
    <SelectTrigger className="hover:bg-accent hover:text-accent-foreground focus:outline-none">
      <SelectValue placeholder="Time" />;
    </SelectTrigger>;
  }

  const territories = Object.entries(USTerritories);

  return (
    <Select
      value={selectedState}
      onValueChange={setSelectedState}
      disabled={territories.length === 0}
    >
      <Label id="state-label" variant="light">
        State
      </Label>
      <Spacer variant="height4" />
      <PlainSelectTrigger
        asChild
        className={cn(
          'w-full justify-between border-2 border-flexcar-neutral80 shadow-inputShadow outline-none ring-0 focus:border-flexcar-blue40 data-[state=open]:border-flexcar-blue40',
          {
            'text-muted-foreground': !selectedState,
            'border-flexcar-red40 shadow-none': errorText !== undefined,
            className,
          }
        )}
      >
        <Button id="state" aria-labelledby="state-label" variant="input" size="none">
          <SelectValue className="p-0" />
          <ChevronDown className="opacity-50" />
        </Button>
      </PlainSelectTrigger>

      {errorText !== undefined && (
        <>
          <Spacer variant="height4" />
          <p className="body3 text-flexcar-red40">{errorText}</p>
        </>
      )}

      <SelectContent className="rounded-2xl">
        {territories.map(([key, value], index) => {
          return (
            <SelectItem
              key={key}
              value={key}
              textValue={value}
              useCustomItemText={true}
              className={cn('cursor-pointer py-2', {
                'rounded-t-2xl': index === 0,
                'rounded-b-2xl': index === territories.length - 1,
              })}
            >
              <p className="body">
                <SelectItemText>{key}</SelectItemText> - {value}
              </p>
            </SelectItem>
          );
        })}
      </SelectContent>

      <input type="hidden" name="state" value={selectedState} />
    </Select>
  );
}
